<template>
  <div class="Pagination">
    <ul class="page-lists">
      <li class="pre-text"><van-button plain type="info" @click="prePage" :disabled="preDisabled">上一页</van-button></li>
      <li class="page-text" @click="showPopup"><span>{{currentPage}}</span> <van-icon name="arrow-down" /></li>
      <li class="next-text"><van-button plain type="info" @click="nextPage" :disabled="nextDisabled">下一页</van-button></li>
    </ul>
    <van-popup v-model="show"  position="bottom" :style="{ height: '40%' }">
      <div class="page-wrap">
        <ul class="pageList">
          <li v-for="item in pageList" @click="changeItem(item)">{{item}}</li>
        </ul>
        <div class="handleCancel" @click="handleCancel">取消</div>
      </div>
    </van-popup>
  </div>
</template>

<script>
  /*
  *
  * 组件使用：
  * <pagetation-list v-if="total > 0"
                     :page-num.sync="pageNum"
                     :current-page.sync="currentPage"
                     :total="total"
                     :page-size="10"
                     :check-index="selectedIndex"
                     @nextPage="getDataList"
                     @prePage="getDataList"
                     @changePage="getDataList"></pagetation-list>
  *
  *
  *
  * props params:
  *     currentPage: 当前页码
  *     total： 数据总条数
  *     pageSize： 每页显示条数
  *     checkIndex: 切换时初始化
  *
  * params：
  *     pageNum： 数据总页数
  *
  * */
  export default {
    name: "Pagetation",
    props: ['currentPage', 'total', 'pageSize', 'pageNum', 'checkIndex', 'checkIndex2'],
    watch:{
      currentPage(n) {
        this.currentPage = n
        this.currentPages = n
        this.initData()
      },
      total(n) {
        this.total = n
      },
      pageNum(n) {
        this.pageNum = n
        this.pageNums = n
        this.pageList = []
        for (let i = 0; i < n; i++) {
          this.pageList.push(i+1);
        }
      },
      checkIndex(n) {
        this.pageNums = this.pageNum
        this.currentPages = this.currentPage
        this.initMethods()
      },
      checkIndex2(n) {
        this.pageNums = this.pageNum
        this.currentPages = this.currentPage
        this.pageList = []
        for (let i = 0; i < n; i++) {
          this.pageList.push(i+1);
        }
        this.initMethods()
      },
    },
    data() {
      return {
        currentPages: 1,
        show: false,
        pageList: [],
        preDisabled: false,
        nextDisabled: false,
        totalPage: 115,  // 总条数
        pageNums: 0,  // 数据总页数
      }
    },
    mounted() {
      this.initMethods()
    },
    methods: {
      initMethods() {
        this.pageNums = Math.ceil(this.total / this.pageSize)
        this.$emit('update:pageNum',this.pageNums)

        for (let i = 0; i < this.pageNums; i++) {
          this.pageList.push(i+1);
        }
        this.initData();
      },
      initData() {
        if(this.currentPages === 1) {
          this.preDisabled = true
        } else {
          this.preDisabled = false
        }
        if(this.currentPages < this.pageNums && this.pageNums > 1) {
          this.nextDisabled = false
        } else {
          this.nextDisabled = true
        }
        this.$emit('update:currentPage', this.currentPages)
      },
      showPopup() {
        this.show = true
      },
      handleCancel() {
        this.show = false
      },
      changeItem(val) {
        // 选择页码
        this.currentPages = val
        this.initData()
        this.show = false
        this.$emit('changePage')
      },
      prePage() {
        // 上一页
        if(this.currentPages > 1) {
          this.currentPages--;
        } else {
          this.preDisabled = true
        }
        this.initData();
        this.$emit('prePage');
      },
      nextPage() {
        // 下一页
        if(this.currentPages < this.pageNums && this.pageNums > 1) {
          this.currentPages++;
        } else {
          this.nextDisabled = true
        }

        this.initData();
        this.$emit('nextPage');
      },
    }
  }
</script>

<style scoped lang="less">
  .Pagination{
    margin: 15px 0 0;
    .page-lists{text-align: center;
      li{
        display: inline-block;font-size: 14px;
        .van-button--plain.van-button--info{padding: 5px 10px;height: auto;}
        &.page-text{margin: 0 5px;padding: 8px 12px;min-width: 80px;border: 1px solid #eee;}
      }
    }
    .page-wrap{
      background: rgba(0,0,0,.7);text-align: center;height: 100%;padding: 30px 10px 10px;color: #3478F7;
      .pageList{
        text-align: center;height: calc(100% - 45px);overflow: hidden;overflow-y: auto;background-color: #fff;border-radius: 10px;margin-bottom: 10px;
        li{padding: 10px 0;border-bottom: 1px solid #eee;}
      }
      .handleCancel{background-color: #fff;padding: 10px 0;border-radius: 10px}
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pagetation/Pagetation.vue